<template lang="pug">
div.page-subtitle {{ subtitle }}
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    subtitle: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
.page-subtitle {
  font-size: 1.2em;
  font-weight: bolder;
  text-align: center;
  margin: 0.5em 0;
}
</style>
